import { SceneSocketState } from '@/../client-generator/generated-clients/plants';
import { Options } from 'vue-class-component';
import SceneActionGeneral from '../SceneActionGeneral';
import EnumToSelectButton from '@/views/components/EnumToSelectButton/EnumToSelectButton.vue';

@Options({
  name: 'ActionSocket',
  components: {
    EnumToSelectButton,
  },
})
export default class ActionSocket extends SceneActionGeneral {
  SceneSocketState = SceneSocketState;

  get isConfirmEnabled() {
    return true;
  }
}
